import Swiper from "swiper";
import PopularPosts from "../../src/js/components/popularPosts";

class BlogCollection {
  slider;
  constructor() {
    this.filterInit();
    this.slidersInit();
    this.loadMoreInit();
    new PopularPosts();
  }
  filterInit = () => {
    const filters = document.querySelectorAll(".js-blog-filter");
    const tags = document.querySelectorAll(".js-tag-filter");
    filters.forEach((filter) => {
      filter.addEventListener("click", () => {
        filters.forEach((f) => {
          if (f != filter) {
            f.classList.remove("active");
          }
        });
        filter.classList.add("active");
        let activeTag = document.querySelector(".js-tag-filter.active");
        this.fetchData(
          "post_filter",
          filter.getAttribute("data-slug"),
          activeTag ? activeTag.getAttribute("data-slug") : null
        );
      });
    });
    tags.forEach((tag) => {
      tag.addEventListener("click", () => {
        tags.forEach((t) => {
          if (t != tag) {
            t.classList.remove("active");
          }
        });
        tag.classList.add("active");
        let activeCat = document.querySelector(".js-blog-filter.active");
        this.fetchData(
          "post_filter",
          activeCat ? activeCat.getAttribute("data-slug") : null,
          tag.getAttribute("data-slug")
        );
      });
    });
  };
  loadMoreInit = () => {
    const btn = document.querySelector(".js-load-more");
    btn.addEventListener("click", () => {
      let activeCat = document.querySelector(".js-blog-filter.active");
      let activeTag = document.querySelector(".js-tag-filter.active");
      let page = btn.getAttribute("data-page");
      this.fetchData(
        "post_filter",
        activeCat ? activeCat.getAttribute("data-slug") : null,
        activeTag ? activeTag.getAttribute("data-slug") : null,
        page
      );
    });
  };
  slidersInit = () => {
    const filterSlider = new Swiper(".js-blog-slider", {
      grabCursor: true,
      slidesPerView: "auto",
      spaceBetween: 8,
    });
    const tagSlider = new Swiper(".js-tag-slider", {
      grabCursor: true,
      slidesPerView: "auto",
    });
  };
  fetchData = async (action, filter, tag, page = 1) => {
    const wrapper = document.querySelector(".js-blog-posts");
    const spinner = document.querySelector(".js-spinner");
    let formData = new FormData();
    formData.append("action", action);
    formData.append("page", page);
    if (filter) {
      formData.append("filter", filter);
    }
    if (tag) {
      formData.append("tag", tag);
    }
    wrapper.classList.add("animating");
    spinner.classList.add("active");
    const response = await fetch(ajaxurl, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    wrapper.innerHTML = data.files;
    wrapper.classList.remove("animating");
    spinner.classList.remove("active");
    this.loadMoreInit();
  };
}
export default BlogCollection;

new BlogCollection();
